import { Button, Modal } from "antd";
import React from "react";
import { useHistory } from "react-router";
import Logo from "../../../Assets/Images/logo.png";
import "./UpgradePlanModal.less";

export const UpgradePlanModal = ({
  setShowUpgradePlanModal,
  showUpgradePlanModal,
}) => {
  const history = useHistory();
  return (
    <Modal
      centered
      visible={showUpgradePlanModal}
      footer={null}
      width={700}
      wrapClassName="upgradePlanModelPOP"
    >
      <div className="upgradePlanModel">
        <div className="text-center">
          <img src={Logo} alt="" />
        </div>
        <h1 className="text-center">Welcome! We're here to help you get things rolling.</h1>
        <h5>Your custom task limit has been reached. Please upgrade your plan to add more custom tasks and get some cool features like QR code scanning. </h5>
        <div className="text-center pt-4">
          <Button
            type="primary"
            shape="round"
            size="large"
            htmlType="submit"
            className="mr-2 mr-md-4"
            onClick={() => history.push(`/settings/subscriptions`)}
          >
            Upgrade Plan
          </Button>
          <Button
            shape="round"
            htmlType="button"
            size="large"
            onClick={() => setShowUpgradePlanModal(false)}
          >
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};
